import React, { Component } from 'react';
import {
    Collapse,
    Container,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import Session from './auth/Session';
import { Roles } from './auth/Roles';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        const isAuthenticated = !!Session.getToken();
        const canManage = isAuthenticated && Session.hasAnyRole([Roles.Admin, Roles.Manager]);
        const canFinance = isAuthenticated && Session.hasAnyRole([Roles.Admin, Roles.FinanceManager]);
        const canReports = isAuthenticated && Session.hasAnyRole([Roles.Admin, Roles.Manager]);
        const canSeeAdmin = isAuthenticated && Session.hasAnyRole([Roles.Admin, Roles.FinanceManager]);
        const isAdmin = isAuthenticated && Session.hasRole(Roles.Admin);

        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/"><img src="logo.png" width="64px" alt="logo"></img>&nbsp;&nbsp;NDS Logistics</NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex" isOpen={!this.state.collapsed} navbar>
                            <Nav className="me-auto" navbar>
                                {canManage && (
                                    <UncontrolledDropdown nav inNavbar>
                                        <DropdownToggle nav caret className="text-dark">Management</DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem tag={Link} to="/dailyroutes">Manage Daily Billing</DropdownItem>
                                            <DropdownItem tag={Link} to="/weeklyroutes">Review Weekly Billing</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                )}
                                {canFinance && (
                                    <UncontrolledDropdown nav inNavbar>
                                        <DropdownToggle nav caret className="text-dark">Finance</DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem tag={Link} to="/invoices">Invoice Review</DropdownItem>
                                            <DropdownItem tag={Link} to="/invoiceaudit">Invoice Audit</DropdownItem>
                                            <DropdownItem tag={Link} to="/paysheets">Paysheet Review</DropdownItem>
                                            <DropdownItem tag={Link} to="/paysheetaudit">Paysheet Audit</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                )}
                                {canReports && (
                                    <UncontrolledDropdown nav inNavbar>
                                        <DropdownToggle nav caret className="text-dark">Reports</DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem tag={Link} to="/daysworked">Driver Days Worked</DropdownItem>
                                            {isAdmin && <DropdownItem tag={Link} to="/reports/approved-invoices">Approved Invoices</DropdownItem>}
                                            {isAdmin && <DropdownItem tag={Link} to="/reports/approved-paysheets">Approved Paysheets</DropdownItem>}
                                            {isAdmin && <DropdownItem tag={Link} to="/reports/paysheet-reconciliation">Weekly Paysheet Reconciliation</DropdownItem>}
                                            {isAdmin && <DropdownItem tag={Link} to="/reports/invoice-reconciliation">Weekly Invoice Reconciliation</DropdownItem>}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                )}
                                {canSeeAdmin && (
                                    <UncontrolledDropdown nav inNavbar>
                                        <DropdownToggle nav caret className="text-dark">Admin</DropdownToggle>
                                        <DropdownMenu>
                                            {isAdmin && <DropdownItem tag={Link} to="/admin?tab=users">Manage Users</DropdownItem>}
                                            {isAdmin && <DropdownItem tag={Link} to="/admin?tab=customers">Manage Customers</DropdownItem>}
                                            {isAdmin && <DropdownItem tag={Link} to="/admin?tab=subcustomers">Manage Sub-Customers</DropdownItem>}
                                            <DropdownItem tag={Link} to="/admin?tab=surcharges">Manage Surcharges</DropdownItem>
                                            <DropdownItem tag={Link} to="/admin?tab=driversurcharges">Manage Driver Surcharges</DropdownItem>
                                            <DropdownItem tag={Link} to="/admin?tab=fuelrates">Manage Fuel Rates</DropdownItem>
                                            <DropdownItem tag={Link} to="/admin?tab=routes">Manage Routes</DropdownItem>
                                            <DropdownItem tag={Link} to="/admin?tab=drivers">Manage Drivers</DropdownItem>
                                            {isAdmin && <DropdownItem tag={Link} to="/admin?tab=transactiontypes">Manage Transaction Types</DropdownItem>}
                                            {isAdmin && <DropdownItem tag={Link} to="/admin?tab=quickbooks">QuickBooks</DropdownItem>}
                                            {isAdmin && <DropdownItem tag={Link} to="/admin/sharepoint-drivers">Import Drivers from SharePoint</DropdownItem>}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                )}
                            </Nav>
                            <ul className="navbar-nav">
                                <LoginMenu />
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
